import { Link } from "react-router-dom";
import { Phone, Mail, Globe, ArrowUpRight, Linkedin, Instagram } from "lucide-react";
import { SaaviMark } from "@/components/SaaviLogo";

const SERVICE_LINKS = [
  ["Performance Marketing", "/services"],
  ["SEO", "/services"],
  ["Social Media", "/services"],
  ["Content & Creative", "/services"],
  ["Web & Automation", "/services"],
  ["Lead Generation", "/services"],
];

const COMPANY_LINKS = [
  ["About", "/about"],
  ["Process", "/process"],
  ["Packages", "/packages"],
  ["Team", "/team"],
  ["Contact", "/contact"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-background">
      <div className="container-saavi py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-5">
              <SaaviMark size={88} />
            </div>
            <p className="text-muted-foreground max-w-md leading-relaxed">
              We help businesses generate high-quality leads, increase revenue, and build powerful digital brands through data-driven marketing strategies.
            </p>
            <div className="mt-8 space-y-3 text-sm">
              <a href="tel:+917985005252" data-testid="footer-phone" className="flex items-center gap-3 hover:text-saavi-blue transition-colors">
                <Phone className="h-4 w-4 text-saavi-blue" /> +91 7985005252
              </a>
              <a href="mailto:hello@saavidigitex.com" data-testid="footer-email" className="flex items-center gap-3 hover:text-saavi-blue transition-colors">
                <Mail className="h-4 w-4 text-saavi-red" /> hello@saavidigitex.com
              </a>
              <a href="https://www.saavidigitex.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-saavi-blue transition-colors">
                <Globe className="h-4 w-4 text-saavi-green" /> www.saavidigitex.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-overline text-muted-foreground mb-4">Services</div>
            <ul className="space-y-2.5 text-sm">
              {SERVICE_LINKS.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-muted-foreground hover:text-foreground transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-overline text-muted-foreground mb-4">Company</div>
            <ul className="space-y-2.5 text-sm">
              {COMPANY_LINKS.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-muted-foreground hover:text-foreground transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-overline text-muted-foreground mb-4">Follow</div>
            <div className="flex flex-wrap gap-2">
              <a
                href="https://www.linkedin.com/in/vikassavant/"
                target="_blank"
                rel="noreferrer"
                aria-label="Vikas Savant on LinkedIn"
                data-testid="footer-social-linkedin"
                className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border hover:border-saavi-blue hover:text-saavi-blue transition-colors"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/saavi_digitex"
                target="_blank"
                rel="noreferrer"
                aria-label="Saavi Digitex on Instagram"
                data-testid="footer-social-instagram"
                className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border hover:border-saavi-red hover:text-saavi-red transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-1 text-sm font-medium hover:text-saavi-blue">
              Start a project <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Saavi Digitex. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <a href="mailto:hello@saavidigitex.com" className="font-mono-overline hover:text-foreground transition-colors">hello@saavidigitex.com</a>
            <span className="font-mono-overline hidden sm:inline">·</span>
            <a href="tel:+917985005252" className="font-mono-overline hover:text-foreground transition-colors hidden sm:inline">+91 7985005252</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
